import Page from "./Page";
import DayPlanner from "../components/planner/DayPlanner";
import PlannerContextProvider from "../context/planner/PlannerContextProvider";
import AppFooter from "../components/footer/AppFooter";
import { useLocation } from "react-router-dom";

const PlannerPage = () => {
  const location = useLocation();
  const navigationState = location.state;

  return (
    <Page pageKey="planner-page" className="planner-page">
      <PlannerContextProvider navigationState={navigationState}>
        <DayPlanner />
      </PlannerContextProvider>
      <AppFooter page="planner" />
    </Page>
  );
};

export default PlannerPage;
